import React from "react";

interface TableHeadProps {
  children: React.ReactNode;
}

const TableHead: React.FC<TableHeadProps> = (props) => {
  const { children } = props;
  return <thead>{children}</thead>;
};

export default TableHead;
